import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarDesignVersionsDto } from "../dto/solar-design-versions.dto"
import { solarDesignVersionsService } from "../services/solar-design-versions.service"

/** The proposal's Vision design versions. The gateway reads stored state only. */
export default function useSolarDesignVersions(
  proposalId: string | undefined,
): UseQueryResult<SolarDesignVersionsDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.designVersions(proposalId ?? ``),
    queryFn: () => solarDesignVersionsService.getVersions(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
